import {
	ControlledEntityDropdown,
	GetSelectedKey,
	PropsOfControlledEntityDropdown,
} from 'components/hookForms';
import React, {useCallback, useMemo} from 'react';
import {Control, useFieldArray, UseFormWatch} from 'react-hook-form';
import {RegulatoryDocument} from 'types';
import {
	BasicDocFields,
	FormRegulatoryDoc,
} from './RegulatoryDocumentsForm.types';
import {useRegDocsFormTranslations} from 'features/RegulatoryDocuments/hooks/RegulatoryDocuments.commonHooks';
import {
	IconButton,
	IDropdownOption,
	IStackItemStyles,
	Label,
	Separator,
	Stack,
	TooltipHost,
} from '@fluentui/react';
import {useTranslation} from 'react-i18next';
import {AppendButton} from 'components/hookForms/AppendButton';
import {v4 as uuidv4} from 'uuid';
import {ProviderThatEnablesGettingTooltipsFromContext} from 'features/localizedTooltips';

type DropdownProps = Omit<
	PropsOfControlledEntityDropdown<BasicDocFields>,
	'selectableOptions' | 'getKey' | 'getText' | 'name'
>;

type Name = 'predecessors';

export interface PredecessorOrSuccessorProps extends DropdownProps {
	control: Control<RegulatoryDocument>;
	regulatoryDocuments: BasicDocFields[];
	regulatoryDocument: FormRegulatoryDoc;
	watch: UseFormWatch<RegulatoryDocument>;
	name: Name;
}

export const KEY_FOR_NO_SELECTION = 'no-selection';

export function PredecessorMultiple({
	control,
	name,
	label,
	regulatoryDocuments,
	regulatoryDocument,
	...other
}: PredecessorOrSuccessorProps) {
	const {fields, remove, append} = useFieldArray({
		control,
		name,
	});

	const {t} = useTranslation('components/referencepicker');

	const regDocOptions: BasicDocFields[] = regulatoryDocuments.filter(
		regDoc => regDoc.id !== regulatoryDocument?.id,
	);

	return (
		<>
			<Label>{label}</Label>
			{fields.map((_item: any, index: any) => {
				return (
					<Stack key={uuidv4()} horizontal tokens={{childrenGap: 8}}>
						<Stack.Item grow>
							<ControlledEntityDropdown
								selectableOptions={regDocOptions}
								name={`${name}.[${index}]`}
								control={control}
								getKey={item => item.id}
								getText={item => item.name}
								tooltipHostProps={{shouldGetTextFromContext: false}}
							/>
						</Stack.Item>
						<Stack.Item>
							<TooltipHost content={t('ToolTipDelete')}>
								<IconButton
									iconProps={{iconName: 'Delete'}}
									onClick={() => remove(index)}
								/>
							</TooltipHost>
						</Stack.Item>
					</Stack>
				);
			})}
			<Stack>
				<Stack.Item>
					<AppendButton
						onClick={() => {
							append({} as never);
						}}
						label={label!}
						name={name}
					/>
				</Stack.Item>
			</Stack>
			<Separator />
		</>
	);
}
